module.exports = __webpack_public_path__ + "resources/35fe06f3dc98a2d30d935ab5f512d70f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundsupermove2.png
// module id = 196
// module chunks = 0